  <div class="tablegraph resizetable hidden">
    <table fixedcols="[0, 1, 2]" id="trenddesctable">
      <tr>
        <th><input type="checkbox" /></th>
        <th>&nbsp;</th>
        <th>{{ 'Object'| translate }}</th>
        <th>{{ 'Name'| translate }}</th>
        <th>{{ 'Scale'| translate }}</th>
        <th>{{ 'Value'| translate }}</th>
      </tr>
    </table>
  </div>
